import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs/internal/Observable';
import { selectCustomerPortalUrl } from 'src/app/root-store/selectors';
import { AppState } from 'src/app/root-store/state';
import { theme } from 'src/environments/theme';

@Component({
    selector: 'app-jobseeker-recruitment-box',
    templateUrl: `./${theme.name}/jobseeker-recruitment-box.component.html`,
    styleUrls: [`./${theme.name}/jobseeker-recruitment-box.component.scss`],
    standalone: false
})
export class JobseekerRecruitmentBoxComponent implements OnInit {
  
  customerPortalUrl$: Observable<string>;

  constructor(private store: Store<AppState>) {}

  ngOnInit() {
    this.customerPortalUrl$ = this.store.pipe(select(selectCustomerPortalUrl));
  }
}
